import validator from "validator";
import Swal from "sweetalert2";
import { APPCOOKIE, APPPACKAGECOOKIE, CustomPackageID } from "./defaults";
import { generateFingerprint } from "device-fingerprint";
import { useHistory, useLocation } from "react-router-dom";
import { useEffect } from "react";

export const checkDuration = (duration) => {
  if (
    duration.days === 0 &&
    duration.hours === 0 &&
    duration.minutes === 0 &&
    duration.seconds === 0
  )
    return false;
  else return true;
};

export const validatePhoneNumber = (number) => {
  const isValidPhoneNumber = validator.isMobilePhone(number);
  return isValidPhoneNumber;
};

export const validateEmail = (email) => {
  const isValidEmail = validator.isEmail(email);
  console.log(isValidEmail);
  return isValidEmail;
};

export const validateZip = (zip) => {
  return /^\d{5}(-\d{4})?$/.test(zip);
};

export const handleInputFocus = (event) => event.target.select();

export const formatNumber = (q) => {
  if (q) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(q);
  } else return 0;
};

export const SAlert = (title, input, label, icon, callback = undefined) => {
  Swal.fire({
    title: title,
    icon: icon,
    input: input,
    inputLabel: label,
    showCancelButton: true,
    allowOutsideClick: false,
    inputValidator: (value) => {
      if (!value) {
        return "Please enter required information";
      } else if (!/^\d+$/.test(value)) {
        return "Please enter a numeric value without any alphanumeric characters";
      } else if (value.length < 4) {
        return "Please enter a numeric value that has at least four digits";
      } else {
        if (callback) {
          callback(value);
        }
      }
    },
  }).then((result) => {
    if (result.isDismissed && callback) {
      callback("RESET666");
    }
  });
};

export const SAText = (title, text, icon, callback = undefined) => {
  Swal.fire({
    icon: icon,
    title: title,
    text: text,
  }).then(() => {
    if (callback) callback();
  });
};

export const SAConfirmReason = (title, text, callback = undefined) => {
  Swal.fire({
    title: title,
    text: text,
    icon: "warning",
    input: "textarea",
    showCancelButton: true,
    // confirmButtonColor: '#3085d6',
    // cancelButtonColor: '#d33',
    confirmButtonText: "Agree and Continue",
    inputValidator: (value) => {
      if (value.trim() !== "") callback(value);
      else return "Please provide a reason for the rejection of this auction.";
    },
  });
};

export const SAConfirm = (title, text, callback = undefined) => {
  Swal.fire({
    title: title,
    text: text,
    icon: "warning",
    showCancelButton: true,
    // confirmButtonColor: '#3085d6',
    // cancelButtonColor: '#d33',
    confirmButtonText: "Agree and Continue",
  }).then((result) => {
    if (result.isConfirmed) {
      if (callback) callback();
    }
  });
};

export const SATextInputValidate = (
  title,
  placeholder,
  defaultValue = "",
  validateInputFn,
  validationErrorMessage = "Invalid input",
  confirmButtonText = "Submit",
) => {
  return Swal.fire({
    title: title,
    input: "text",
    inputPlaceholder: placeholder,
    inputValue: defaultValue, // Set the default value
    showCancelButton: true,
    confirmButtonText: confirmButtonText,
    preConfirm: (value) => {
      if (validateInputFn) {
        const error = validateInputFn(value);
        if (!error) {
          Swal.showValidationMessage(validationErrorMessage);
          return false;
        }
      }
      return value;
    },
  }).then((result) => {
    return result.isConfirmed ? result.value : null; // Return input value or null if canceled
  });
};

export const SATextInput = (
  title,
  placeholder,
  defaultValue = "",
  confirmButtonText = "Submit",
) => {
  return Swal.fire({
    title: title,
    input: "text",
    inputPlaceholder: placeholder,
    inputValue: defaultValue, // Set the default value
    showCancelButton: true,
    confirmButtonText: confirmButtonText,
  }).then((result) => {
    return result.isConfirmed ? result.value : null; // Return input value or null if canceled
  });
};

export const SATextAreaInput = (
  title,
  placeholder,
  defaultValue = "",
  confirmButtonText = "Submit",
) => {
  return Swal.fire({
    title: title,
    input: "textarea",
    inputPlaceholder: placeholder,
    inputValue: defaultValue, // Set the default value
    showCancelButton: true,
    confirmButtonText: confirmButtonText,
  }).then((result) => {
    return result.isConfirmed ? result.value : null; // Return input value or null if canceled
  });
};

export const SADropdown = (title, text, confirmButtonText, options) => {
  return Swal.fire({
    title: title,
    text: text,
    icon: "",
    showCancelButton: true,
    confirmButtonText: confirmButtonText,
    input: "select",
    inputOptions: options,
    inputValidator: (value) => {
      return value ? undefined : "Please select an option";
    },
  }).then((result) => {
    if (result.isConfirmed) {
      const selectedOption = result.value;

      return selectedOption; // If not "Other", return the selected option
    }
  });
};

export const SADropdownOrOther = (title, text, confirmButtonText, options) => {
  return Swal.fire({
    title: title,
    text: text,
    icon: "",
    showCancelButton: true,
    confirmButtonText: confirmButtonText,
    input: "select",
    inputOptions: options,
    inputValidator: (value) => {
      return value ? undefined : "Please select an option";
    },
  }).then((result) => {
    if (result.isConfirmed) {
      const selectedOption = result.value;

      // If the user selects "Other", show an additional text input
      if (selectedOption === "other") {
        return Swal.fire({
          title: `${title} - Please Specify`,
          input: "textarea",
          inputPlaceholder: "Enter your option here",
          confirmButtonText: "Submit",
          showCancelButton: true,
        }).then((textResult) => {
          if (textResult.isConfirmed && textResult.value) {
            return textResult.value; // Return the custom text input
          }
        });
      }

      return selectedOption; // If not "Other", return the selected option
    }
  });
};

export const SAFilesAndCopySections = (
  files = [],
  sections = [],
  props = {},
) => {
  // files = [{ id, name, url }]
  // sections = [{ title, content }]

  const checkboxHtml = files
    .map(
      (f) => `
        <div style="margin:4px 0; text-align:left;">
          <label>
            <input type="checkbox" class="swal-file-checkbox" value="${f.id}" data-url="${f.url}">
            ${f.name}
          </label>
        </div>
      `,
    )
    .join("");

  const sectionHtml = sections
    .map(
      (sec, idx) => `
        <div style="padding:10px; border:1px solid #ddd; border-radius:6px; margin-top:15px; position:relative;">
          <div style="font-weight:600; margin-bottom:5px;">${sec.title}</div>

          <pre id="swal-copy-content-${idx}" 
               style="background:#f7f7f7; padding:10px; border-radius:4px; max-height:150px; overflow-y:auto; white-space:pre-wrap;">
${sec.content}
          </pre>

          <button class="swal-copy-btn" data-target="swal-copy-content-${idx}"
                  style="position:absolute; top:10px; right:10px; border:none; background:none; cursor:pointer;">
            📋
          </button>
        </div>
      `,
    )
    .join("");
  return Swal.fire({
    title: "Download Files & Copy Data",
    width: "650px",
    html: `
    <div style="text-align:left; max-height:250px; overflow-y:auto; padding:8px; border:1px solid #ddd; border-radius:6px;">
      <strong>Files</strong>
      ${checkboxHtml}
    </div>

    <button id="swal-download-btn" 
            class="swal2-confirm swal2-styled" 
            style="margin-top:12px; width:90%;">
      Download Selected Files
    </button>

    <hr style="margin:20px 0;">

    ${sectionHtml}
  `,
    showConfirmButton: false,
    showCancelButton: true,
    cancelButtonText: "Close",
    didOpen: () => {
      // ---- DOWNLOAD BUTTON ----
      const downloadBtn = document.getElementById("swal-download-btn");
      downloadBtn?.addEventListener("click", async () => {
        const checks = Array.from(
          document.querySelectorAll(".swal-file-checkbox:checked"),
        );

        if (checks.length === 0) {
          Swal.showValidationMessage?.("Please select at least one file.");
          return;
        }

        for (const cb of checks) {
          console.log("cb", cb);
          if (cb.value === "invoice") {
            await props.downloadInvoicePDF();
          }

          if (cb.value === "receipt") {
            await props.downloadReceiptPDF();
          }

          await new Promise((r) => setTimeout(r, 250));
        }
      });

      // ---- COPY BUTTONS ----
      document.querySelectorAll(".swal-copy-btn").forEach((btn) => {
        btn.addEventListener("click", () => {
          const targetId = btn.getAttribute("data-target");
          const pre = document.getElementById(targetId);
          if (!pre) return;

          const text = pre.innerText.trim();
          navigator.clipboard.writeText(text);

          btn.innerHTML = "✔️";
          setTimeout(() => (btn.innerHTML = "📋"), 1000);
        });
      });
    },
  });
};

export const SAUpdateBankForm = (banklist = []) => {
  const bankOptions = banklist
    .map((bank) => `<option value="${bank}">${bank}</option>`)
    .join("");
  return Swal.fire({
    title: "Associate Bank with Card",
    html: `
      <label for="swal-bank" class="mt-3 mb-0">*Bank:</label><br />
      <select id="swal-bank" class="swal2-select mt-0">
        <option value="">Select a bank</option>
        ${bankOptions}
        <option value="Other">Other</option>
      </select>

      <div id="swal-other-container" style="display: none; text-align:center;">
        <br />
        <label for="swal-other-bank">Bank Name:</label><br />
        <input id="swal-other-bank" class="swal2-input" style="width:75%;" placeholder="Enter Bank" />
      </div>
    `,
    showCancelButton: true,
    confirmButtonText: "Submit",
    focusConfirm: false,
    didOpen: () => {
      const reasonSelect = document.getElementById("swal-bank");
      const otherReasonContainer = document.getElementById(
        "swal-other-container",
      );

      reasonSelect.addEventListener("change", () => {
        otherReasonContainer.style.display =
          reasonSelect.value === "Other" ? "block" : "none";
      });
    },
    preConfirm: () => {
      const bankName = document.getElementById("swal-bank").value;
      const otherbankName = document.getElementById("swal-other-bank").value;
      if (!bankName) {
        Swal.showValidationMessage("Please select a reason.");
        return false;
      }

      return {
        bankName: bankName === "Other" ? otherbankName : bankName,
      };
    },
  }).then((result) => {
    if (result.isConfirmed) {
      return result.value;
    }
  });
};

export const SADisputeForm = () => {
  return Swal.fire({
    title: "Dispute Details",
    html: `
      <label for="swal-dispute-status" class="mb-0">*Status:</label>
      <br />
      <select id="swal-dispute-status" class="swal2-select mt-0">
        <option value="" selected>Select a status</option>
        <option value="Fighting Dispute">Fighting Dispute</option>
        <option value="Paid Out">Paid Out</option>
        <option value="Lost Dispute">Lost Dispute</option>
        <option value="Won Dispute">Won Dispute</option>
      </select>

      <br />
      <label for="swal-reason" class="mt-3 mb-0">*Reason:</label><br />
      <select id="swal-reason" class="swal2-select mt-0">
        <option value="">Select a reason</option>
        <option value="Fraud">Fraud</option>
        <option value="Did not authorize the purchase">Did not authorize the purchase</option>
        <option value="No Knowledge of Charge">No Knowledge of Charge</option>
        <option value="customer claimed credit was owed">Customer claimed credit was owed</option>
        <option value="Product not received">Product not received</option>
        <option value="Other">Other</option>
      </select>

     <div id="swal-other-container" style="display: none; align-items: center;">
      <label for="swal-other-reason" style="margin-right: 10px;">Other:</label>
      <textarea id="swal-other-reason" class="swal2-textarea" placeholder="Enter reason"></textarea>
      </div>

      <br />
      <label><input type="checkbox" id="swal-dispute-valid" class="mt-3"> Is dispute valid?</label><br>

      <label for="swal-date-disputed">Date Disputed:</label>
      <input type="date" id="swal-date-disputed" class="swal2-input">
      <p id="swal-date-message" style="font-size: 12px; color: gray; margin-top: 5px;">
        Default date is today when left blank
      </p>
    `,
    showCancelButton: true,
    confirmButtonText: "Submit",
    focusConfirm: false,
    didOpen: () => {
      const reasonSelect = document.getElementById("swal-reason");
      const otherReasonContainer = document.getElementById(
        "swal-other-container",
      );

      reasonSelect.addEventListener("change", () => {
        otherReasonContainer.style.display =
          reasonSelect.value === "Other" ? "flex" : "none";
      });
    },
    preConfirm: () => {
      const disputeValid =
        document.getElementById("swal-dispute-valid").checked;
      const disputeStatus = document.getElementById(
        "swal-dispute-status",
      ).value;
      const disputeReason = document.getElementById("swal-reason").value;
      const otherDisputeReason =
        document.getElementById("swal-other-reason").value;
      const dateTimeDisputed =
        document.getElementById("swal-date-disputed").value ||
        new Date().toISOString().split("T")[0]; // Default to today

      if (!disputeStatus) {
        Swal.showValidationMessage("Please select a status.");
        return false;
      }

      if (!disputeReason) {
        Swal.showValidationMessage("Please select a reason.");
        return false;
      }

      return {
        disputeValid: disputeValid,
        disputeStatus: disputeStatus,
        disputeReason:
          disputeReason === "Other" ? otherDisputeReason : disputeReason,
        dateTimeDisputed: dateTimeDisputed,
      };
    },
  }).then((result) => {
    if (result.isConfirmed) {
      return result.value;
    }
  });
};

export const FormatPhone = (e, stateFunc, override = false) => {
  let curval = e.target.value;

  // Remove all non-digit characters to simplify formatting
  let cleaned = curval.replace(/\D/g, "");

  // Format the phone number
  let formatted = "";
  if (cleaned.length <= 3) {
    formatted = cleaned;
  } else if (cleaned.length <= 6) {
    formatted = `${cleaned.slice(0, 3)}-${cleaned.slice(3)}`;
  } else {
    formatted = `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(
      6,
      10,
    )}`;
  }

  if (!override) stateFunc((prevState) => ({ ...prevState, phone: formatted }));
  else stateFunc(formatted);
};

export const SimpleFormatPhone = (value) => {
  let curval = value;

  // Remove all non-digit characters to simplify formatting
  let cleaned = curval.replace(/\D/g, "");

  // Format the phone number
  let formatted = "";
  if (cleaned.length <= 3) {
    formatted = cleaned;
  } else if (cleaned.length <= 6) {
    formatted = `${cleaned.slice(0, 3)}-${cleaned.slice(3)}`;
  } else {
    formatted = `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(
      6,
      10,
    )}`;
  }

  return formatted;
};

export const SimpleFormatTransactionID = (value) => {
  let curval = value;

  // Remove all non-alphanumeric characters to simplify formatting
  let cleaned = curval.replace(/[^a-zA-Z0-9]/g, "");

  // Format the transaction ID
  let formatted = "";
  if (cleaned.length <= 5) {
    formatted = cleaned;
  } else if (cleaned.length <= 10) {
    formatted = `${cleaned.slice(0, 5)}-${cleaned.slice(5)}`;
  } else {
    formatted = `${cleaned.slice(0, 5)}-${cleaned.slice(5, 10)}`;
  }

  return formatted;
};

export function makeid(length) {
  var result = "";
  var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export const getDeviceFingerprint = () => {
  // const { ClientJS } = require ('clientjs');
  // const fingerprintClient = new ClientJS();
  // const fingerprint = fingerprintClient.getFingerprint();
  // return fingerprint;

  const fingerprint = generateFingerprint();

  return fingerprint;
};

export const checkPasswordStrength = (password) => {
  const upperCaseRegex = /[A-Z]/;
  const numberRegex = /[0-9]/;
  const specialCharacterRegex = /[^A-Za-zÀ-ÖØ-öø-ÿ]+/;

  if (!password.match(numberRegex)) {
    return {
      status: false,
      error: "Password must contain at least one number.",
    };
  }

  if (!password.match(upperCaseRegex)) {
    return {
      status: false,
      error: "Password must contain at least one uppercase letter.",
    };
  }

  if (!password.match(numberRegex)) {
    return {
      status: false,
      error: "Password must contain at least one lowercase letter.",
    };
  }

  if (!password.match(specialCharacterRegex)) {
    return {
      status: false,
      error: "Password must contain at least one special character.",
    };
  }

  return { status: true, error: null };
};

export const validateWholeNumber = (value) => {
  const wholeNumberRegex = /^\d*$/; // Regular expression to match whole numbers
  return wholeNumberRegex.test(value);
};

export const isTokenExpired = (time) => {
  // if(time === undefined || Date.now() > parseInt(time) + SessionTimeout) {
  if (time === undefined || Date.now() > parseInt(time)) {
    localStorage.removeItem(APPCOOKIE);
    // sessionStorage.removeItem(APPPACKAGECOOKIE);
    return true;
  } else {
    return false;
  }
};

export function usePackageId() {
  const location = useLocation();

  useEffect(() => {
    const parts = location.pathname.split("/");
    const inCheckout = parts[1] === "checkout";
    if (inCheckout) {
      const id = parts[2];
      if (id && id != "null" && id != null) {
        sessionStorage.setItem(APPPACKAGECOOKIE, id);
      }
    } else {
      sessionStorage.setItem(APPPACKAGECOOKIE, CustomPackageID);
    }
  }, [location.pathname]);

  if (sessionStorage.getItem(APPPACKAGECOOKIE))
    return sessionStorage.getItem(APPPACKAGECOOKIE);
  else return CustomPackageID;
  // Always return current or stored packageId
  // return sessionStorage.getItem(APPPACKAGECOOKIE);
}
